import React, {PureComponent} from "react";
import $ from "jquery";
import "../../css/elements/diagnosticsSideBar.css";
import "../../css/elements/led_lights/red.css";
import "../../css/elements/led_lights/yellow.css";
import "../../css/elements/led_lights/green.css";
import "../../css/elements/led_lights/blue.css";
import "../../css/elements/led_lights/white.css";

import gsm_0 from "../../img/gsm/gsm_0.svg";
import gsm_1 from "../../img/gsm/gsm_1.svg";
import gsm_2 from "../../img/gsm/gsm_2.svg";
import gsm_3 from "../../img/gsm/gsm_3.svg";
import gsm_4 from "../../img/gsm/gsm_4.svg";
import gsm_5 from "../../img/gsm/gsm_5.svg";

import gMapsIcon from "../../img/gmaps_icon.png";

import RealTimeGraph from "../independentComponents/realTimeGraphComponent";
import {Modal} from "react-responsive-modal";
import Alert from "react-s-alert";
import {formatDate, prefixWZeroes} from "../functions/utils";
import ReactTooltip from "react-tooltip";
import {
    closeSocket,
    confirmIdentity,
    connectSocket,
    subscribeCarToServer,
    subscribeDashToServer,
    subscribeToDiagnosticInfo,
    subscribeToMapInfo,
    subscribeToTelemetry,
    subscribeClock,
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;
const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

const device_on_interval = 33000;
const auto_refresh = 90000;

class PopoutDiagMonitor extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            toggleCarList: false,
            carList: [{
                id: 0,
                livery_number: 0,
                short_name: "---",
                title: "---",
                speedSource: "OBD",
                toggleCarList: true,
                carID: -1,
                pfu: null,
            }],
            confirmedOrg: true,
            diagnosis: {
                sat: false,
                fix: false,
                bat: false,
                ena: false,
                eim: false,
                eos: false,
                elu: false,
                elg: false,
                eip: false,
                sas: false,
                sim: false,
                sop: false,
                soc: false,
                sic: false,
                ssg: false,
                svl: false,
                smc: false,
                pcd: false,
                pdu: false,
                pim: false,
                pip: false,
                prt: false,
                doc: false,
                per1: {},
                per2: {},
                per3: {},
                per4: {},
            },
            telemetry: {
                clt: false,
                spg: false,
                spo: false,
                rpm: false,
                etm: false,
                thr: false,
                xyz: false,
                lui: false,
            },
            currentCarLat: false,
            currentCarLng: false,
            glowEffect: false,
            carID: null,
            peripheralUpdateStatus: null,
            numConnectedClients: null,
        };

        this.getCarList = this.getCarList.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.closeNav = this.closeNav.bind(this);
        this.updateCurrentCarID = this.updateCurrentCarID.bind(this);
        this.resetDash = this.resetDash.bind(this);
        this.handleToggleGlow = this.handleToggleGlow.bind(this);
        this.compareRaceStatus = this.compareRaceStatus.bind(this);
        this.updatePeripheralUpdateStatus = this.updatePeripheralUpdateStatus.bind(this);
    }

    toggleSidebar() {
        this.setState({
            toggleCarList: !this.state.toggleCarList,
        }, () => {
            if (this.state.toggleCarList) {
                if ($(window).width() > 1400) {
                    // Set the width of the sidebar to 250px and the left margin of the page content to 250px
                    document.getElementById("mySidebar").style.width = "40%";
                    document.getElementById("main").style.marginLeft = "40%";
                } else {
                    // Hide clock if screen too small
                    document.getElementById("myNav").style.width = "100%";
                }
            } else {
                if ($(window).width() > 1400) {
                    // Set the width of the sidebar to 0 and the left margin of the page content to 0
                    document.getElementById("mySidebar").style.width = "0";
                    document.getElementById("main").style.marginLeft = "0";
                } else {
                    document.getElementById("myNav").style.width = "0%";
                }
            }
        });
    }

    closeNav() {
        if (!this.state.toggleCarList) {
            document.getElementById("myNav").style.width = "0%";
        }
    }

    updateCurrentCarID(id, callback) {
        this.resetDash();
        this.setState({
            carID: id,
        });

        // Notify server of new connection
        subscribeCarToServer(this.props.match.params.eventID, id, () => {

        });

        if ($(window).width() <= 1400) {
            setTimeout(() => {
                this.toggleSidebar();
            }, 500);
        }
        // Subscribe to diagnosis info
        subscribeToDiagnosticInfo(this.state.carID, id, false, (err, diagnosis) => {
            this.setState({
                diagnosis: diagnosis,
            });
        });

        subscribeToTelemetry(("car_" + this.state.carID + "-telemetry-data"), ("car_" + id + "-telemetry-data"), false, (err, telemetry) => {
            this.setState({
                telemetry: telemetry,
            });
        });

        for (let i = 0; i < this.state.carList.length; i++) {
            if (this.state.carList[i].id === id) {
                this.setState({
                    carID: id,
                    lastCommnsConnectionStart: this.state.carList[i].last_comms_start_timestamp,
                    lastCommnsConnectionEnd: this.state.carList[i].last_comms_end_timestamp,
                    lastCommnsBrkMtv: this.state.carList[i].last_comms_end_motive,
                }, () => {
                    callback();
                });
                break;
            }
        }
    }

    resetDash() {
        this.setState({
            diagnosis: {
                sat: false,
                fix: false,
                bat: false,
                ena: false,
                eim: false,
                eos: false,
                elu: false,
                elg: false,
                eip: false,
                sas: false,
                sim: false,
                sop: false,
                soc: false,
                sic: false,
                ssg: false,
                svl: false,
                smc: false,
                pcd: false,
                pdu: false,
                pim: false,
                pip: false,
                prt: false,
                doc: false,
                per1: {},
                per2: {},
                per3: {},
                per4: {},
            },
            telemetry: {
                clt: false,
                spg: false,
                spo: false,
                rpm: false,
                etm: false,
                thr: false,
                xyz: false,
                lui: false,
            },
            currentCarLat: false,
            currentCarLng: false,
        });
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {

                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), this.state.carID, this.props.match.params.sessionID, this.props.match.params.eventID, "DIAGNOSTICS", (msg) => {
                    console.log("[DIAGNOSTIC]" + msg);

                    this.getCarList((err, message) => {
                        if (err) {
                            console.error(message, err);
                        } else {
                            console.log(message);
                        }
                    });

                    // DS
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("[DIAGNOSTIC] DEDICATED STREAM SUBSCRIBED");
                    });

                    subscribeToMapInfo(this.props.match.params.eventID, false, (error, coords) => {
                        for (let i = 0; i < coords.length; i++) {
                            if (coords[i].cid === this.state.carID) {
                                this.setState({
                                    currentCarLat: coords[i].lat,
                                    currentCarLng: coords[i].lng,
                                });
                                break;
                            }
                        }
                    });

                    subscribeClock((obj) => {
                        if (obj.cli !== null && obj.cli !== undefined) {
                            this.setState({
                                numConnectedClients: obj.cli,
                            });
                        } else {
                            this.setState({
                                numConnectedClients: null,
                            });
                        }
                    });
                });
            } else {
                this.setState({
                    confirmedOrg: false,
                });
            }
        });

        setTimeout(() => {
            this.toggleSidebar();
        }, 800);
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[DIAGNOSTICS] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeCarToServer(this.props.match.params.eventID, this.state.carID, () => {
            console.log("[DIAGNOSTICS] DEDICATED CAR STREAM UNSUBSCRIBED");
        });
        subscribeToDiagnosticInfo(this.state.carID, null, true, null);
        subscribeToTelemetry(("car_" + this.state.carID + "-telemetry-data"), null, false, null);
        subscribeToMapInfo(this.props.match.params.eventID, true, null);
        closeSocket();

    }

    /* INTER-COMPONENT INTERACTION */
    updatePeripheralUpdateStatus(pfu) {
        this.setState({
            peripheralUpdateStatus: pfu,
        });
    }

    /* GET INFO */
    getCarList(callback) {
        console.log("[DIAGNOSTICS] Mounting car list...");
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getCarList",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                userID: helper.props.match.params.userID,
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                if (data.length > 0) {
                    data.sort(helper.compareRaceStatus);
                    helper.setState({
                        carList: data,
                    });
                }
                callback(null, "[DIAGNOSTICS] VEHICLE LIST UPDATED!");
            }, error: function (err) {
                if (err) {
                    callback(err, "[DIAGNOSTICS] Error getting vehicle list!");
                }
                helper.setState({
                    carList: [{
                        id: 0,
                        livery_number: 0,
                        short_name: "---",
                        title: "---",
                        speedSource: "OBD",
                    }]
                });
            }
        });
    }

    /* HANDLERS */
    handleToggleGlow(callback) {
        this.setState({
            glowEffect: !this.state.glowEffect,
        }, () => {
            callback();
        });
    }

    /* SORTING METHODS */
    compareRaceStatus(a, b) {
        if (a.rsi < b.rsi) {
            return -1;
        } else if (a.rsi > b.rsi) {
            return 1;
        }
    }

    /* RENDER */
    render() {
        if (this.state.confirmedOrg) {
            return (
                <>
                    <div className="loading">
                        <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                    </div>
                    <div id={$(window).width() > 1400 ? "mySidebar" : "myNav"} className={$(window).width() > 1200 ? "sidebar" : "overlay"}>
                        <div className={$(window).width() > 1400 ? "" : "overlay-content"}>
                            <div className={"col-xs-12"}>
                                <span className={"closebtn"} onClick={this.toggleSidebar} style={{cursor: "pointer", color: "#FFFFFF", position: "initial", float: "right"}}>&times;</span>
                            </div>
                            <TopTable
                                carID={this.state.carID}
                                updateCurrentCarID={this.updateCurrentCarID}
                                getCarList={this.getCarList}
                                carList={this.state.carList}
                                eventID={this.props.match.params.eventID}
                                numSat={parseInt(this.state.numSat)}
                                t={this.props.t}
                                glowEffect={this.state.glowEffect}
                                handleToggleGlow={this.handleToggleGlow}
                                updatePeripheralUpdateStatus={this.updatePeripheralUpdateStatus}
                                numConnectedClients={this.state.numConnectedClients}
                            />
                        </div>
                    </div>
                    <div id={"main"} style={{overflowX: "hidden"}}>
                        <div className={"row"}>
                            <div className={"col-xs-12"}>
                                <button className={"openbtn btn btn-primary btn-block button"} onClick={this.toggleSidebar}>
                                    <i className="fas fa-align-justify"/> <i className="fas fa-car"/>
                                </button>
                            </div>
                        </div>
                        <div className={"row w3-animate-fading"}>
                            <div className={"col-md-9 row-flex"}>
                                <EmnifyPanel
                                    diagnosis={this.state.diagnosis}
                                    telemetry={this.state.telemetry}
                                    t={this.props.t}
                                    glowEffect={this.state.glowEffect}
                                    cookies={this.props.cookies}
                                    eventID={this.props.match.params.eventID}
                                    carID={this.state.carID}
                                />
                                <PeripheralsList
                                    diagnosis={this.state.diagnosis}
                                    carID={this.state.carID}
                                    t={this.props.t}
                                    glowEffect={this.state.glowEffect}
                                    peripheralUpdateStatus={this.state.peripheralUpdateStatus}
                                    cookies={this.props.cookies}
                                />
                                <RealtimeGraphs
                                    telemetry={this.state.telemetry}
                                    t={this.props.t}
                                    glowEffect={this.state.glowEffect}
                                />
                            </div>
                            <StatusReport
                                carID={this.state.carID}
                                lastCommnsConnectionStart={this.state.lastCommnsConnectionStart}
                                lastCommnsConnectionEnd={this.state.lastCommnsConnectionEnd}
                                lastCommnsBrkMtv={this.state.lastCommnsBrkMtv}
                                diagnosis={this.state.diagnosis}
                                telemetry={this.state.telemetry}
                                currentCarLat={this.state.currentCarLat}
                                currentCarLng={this.state.currentCarLng}
                                t={this.props.t}
                                glowEffect={this.state.glowEffect}
                            />
                        </div>
                    </div>
                </>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

class EmnifyPanel extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            endpointStatus: "red",
            endpointStatusDesc: "---",
            simCardStatus: "red",
            simCardStatusDesc: "---",
            currentCarIMEI: "---",
        };

        this.getIMEIByCarID = this.getIMEIByCarID.bind(this);
    }

    // LIFE CYCLE
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.diagnosis !== this.props.diagnosis) {

            //reset current IMEI and retrieve new one
            this.setState({
                currentCarIMEI: "---",
            }, () => {
                this.getIMEIByCarID();
            });

            // SWITCH LED color for endpoint
            switch (this.props.diagnosis.eos) {
                case ("ONLINE"): {
                    this.setState({
                        endpointStatus: "green",
                        endpointStatusDesc: this.props.t("online").toUpperCase(),
                    });
                    break;
                }
                case ("OFFLINE"): {
                    this.setState({
                        endpointStatus: "red",
                        endpointStatusDesc: this.props.t("offline").toUpperCase(),
                    });
                    break;
                }
                case ("ATTACHED"): {
                    this.setState({
                        endpointStatus: "blue",
                        endpointStatusDesc: this.props.t("attached").toUpperCase(),
                    });
                    break;
                }
                case ("BLOCKED"): {
                    this.setState({
                        endpointStatus: "yellow",
                        endpointStatusDesc: this.props.t("blocked").toUpperCase(),
                    });
                    break;
                }
                default: {
                    this.setState({
                        endpointStatus: "red",
                        endpointStatusDesc: this.props.diagnosis.eos,
                    });
                    break;
                }
            }

            // SWITCH LED color for SIM card
            switch (this.props.diagnosis.sas) {
                case -1: {
                    this.setState({
                        simCardStatus: "yellow",
                        simCardStatusDesc: this.props.t("unknown").toUpperCase(),
                    });
                    break;
                }
                case 0: {
                    this.setState({
                        simCardStatus: "blue",
                        simCardStatusDesc: this.props.t("issued").toUpperCase(),
                    });
                    break;
                }
                case 1: {
                    this.setState({
                        simCardStatus: "green",
                        simCardStatusDesc: this.props.t("active").toUpperCase(),
                    });
                    break;
                }
                case 2: {
                    this.setState({
                        simCardStatus: "red",
                        simCardStatusDesc: this.props.t("suspended").toUpperCase(),
                    });
                    break;
                }
                default: {
                    this.setState({
                        simCardStatus: "yellow",
                        simCardStatusDesc: this.props.t("unknown").toUpperCase(),
                    });
                    break;
                }
            }
        }
    }

    // GET DATA
    getIMEIByCarID() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getIMEIbyCarID",
            dataType: "json",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                carID: helper.props.carID,
                eventID: parseInt(helper.props.eventID),
            },
            success: function (data) {
                helper.setState({
                    currentCarIMEI: data,
                });
            }, error: function (err) {
                if (err) {
                    console.error("[DIAGNOSTIC] Error fetching car device IMEI.", err);
                }
            }
        });
    }

    render() {
        return (
            <>
                <div className={"col-xs-12 row-flex"} style={{padding: 0}}>
                    <div className={"col-xs-12 col-sm-6 col-md-7"} style={{paddingLeft: 6, paddingRight: 6}}>
                        <div className={"App_panel row-flex"}>
                            <div className={"col-xs-12 text-left App_containerTitle"}>
                                <div className={"col-xs-6"}>
                                    <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("endpoint")}</span>
                                </div>
                                <div className={"col-xs-6"}>
                                    <div style={{display: "flex", alignItems: "center", padding: 0, float: "right"}}>
                                        <div className={"led-" + this.state.endpointStatus + (this.props.glowEffect ? "" : "-static")} style={{float: "left", margin: 5}}/>
                                        <span className={"App_small_title App_white_text"} style={{margin: 5}}>{this.state.endpointStatusDesc}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-xs-12 row-flex"}>
                                <div className={"col-xs-12 col-sm-5 col-md-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("lastUpdated")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 col-md-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.elu ? this.props.diagnosis.elu : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 col-md-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("endpointName")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 col-md-7 text-left allow-select-text"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.ena ? this.props.diagnosis.ena : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 col-md-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("endpointIP")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 col-md-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.eip ? this.props.diagnosis.eip : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 col-md-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("imei")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 col-md-7 text-left allow-select-text"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.state.currentCarIMEI}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"col-xs-12 col-sm-6 col-md-5"} style={{paddingLeft: 6, paddingRight: 6}}>
                        <div className={"App_panel row-flex"}>
                            <div className={"col-xs-12 text-left App_containerTitle"}>
                                <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("pdp")}</span>
                            </div>
                            <div className={"col-xs-12 row-flex"}>
                                <div className={"col-xs-12 col-sm-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("creationDate")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.pcd ? formatDate(this.props.diagnosis.pcd, Intl.DateTimeFormat().resolvedOptions().timeZone) : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("duration")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.pdu ? this.props.diagnosis.pdu : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("imeisv")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.pim ? this.props.diagnosis.pim : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("IPAddress")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.pip ? this.props.diagnosis.pip : "---"}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("ratType")}</p>
                                </div>
                                <div className={"col-xs-12 col-sm-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.prt ? this.props.diagnosis.prt : "---"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"col-xs-12"} style={{paddingLeft: 6, paddingRight: 6}}>
                    <div className={"App_panel row-flex"}>
                        <div className={"col-xs-12 text-left App_containerTitle"}>
                            <div className={"col-xs-6"}>
                                <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("simCard")}</span>
                            </div>
                            <div className={"col-xs-6"}>
                                <div className={"text-center"} style={{display: "flex", alignItems: "center", float: "right"}}>
                                    <div className={"led-" + this.state.simCardStatus + (this.props.glowEffect ? "" : "-static")} style={{float: "left", margin: 5}}/>
                                    <span className={"App_small_title App_white_text"} style={{margin: 5}}>{this.state.simCardStatusDesc}</span>
                                </div>
                            </div>
                        </div>
                        <div className={"col-xs-12 row-flex"}>
                            <div className={"col-xs-12 row-flex"} style={{marginTop: 10}}>
                                <div className={"col-xs-12 col-sm-4"}>
                                    <div className={"col-xs-12 col-sm-5 text-left"} style={{padding: 2}}>
                                        <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("operator").toUpperCase()}</p>
                                    </div>
                                    <div className={"col-xs-12 col-sm-7 text-left"}>
                                        <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.sop ? this.props.diagnosis.sop + " (" + this.props.diagnosis.soc + ")" : "---"}</p>
                                    </div>
                                </div>
                                <div className={"col-xs-12 col-sm-4"}>
                                    <div className={"col-xs-12 col-sm-4 text-left"} style={{padding: 2}}>
                                        <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("imsi")}</p>
                                    </div>
                                    <div className={"col-xs-12 col-sm-6 text-left"} style={{padding: 2}}>
                                        <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.sim ? this.props.diagnosis.sim : "---"}</p>
                                    </div>
                                </div>
                                <div className={"col-xs-12 col-sm-4"}>
                                    <div className={"col-xs-12 col-sm-4 text-left"} style={{padding: 2}}>
                                        <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("iccid")}</p>
                                    </div>
                                    <div className={"col-xs-12 col-sm-6 text-left"} style={{padding: 2}}>
                                        <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.sic ? this.props.diagnosis.sic : "---"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

class StatusReport extends PureComponent {

    constructor(props) {
        super(props);

        this.handleRefreshDevice = this.handleRefreshDevice.bind(this);
        this.handleResetDevice = this.handleResetDevice.bind(this);
        this.handleForceNewConnection = this.handleForceNewConnection.bind(this);
    }

    handleRefreshDevice() {
        const helper = this;
        $.ajax({
            type: "GET",
            url: telemetryIP + ":" + messagePort + "/device-diagnosis-refresh?carId=" + helper.props.carID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function (data) {
                console.log("[DIAGNOSTICS] Successfully sent device refresh request.");
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("forcedRefreshSuccess") + '!</span>', {
                    position: "bottom-left",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error("[DIAGNOSTIC] Error sending device refresh request.", err);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("forcedRefreshError") + '!</span>', {
                        position: "bottom-left",
                        effect: "genie",
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    handleResetDevice() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-RESTART&carId=" + helper.props.carID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function (data) {
                console.log("[DIAGNOSTICS] Successfully sent device reset request.");
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("forcedResetSuccess") + '</span>', {
                    position: "bottom-left",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error("[DIAGNOSTIC] Error sending device reset request.", err);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("forcedResetError") + '</span>', {
                        position: "bottom-left",
                        effect: "genie",
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    handleForceNewConnection() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-FORCE-RECONN&carId=" + helper.props.carID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function (data) {
                console.log("[DIAGNOSTICS] Successfully sent device force-reconnection request.");
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("forcedConnectionSuccess") + '</span>', {
                    position: "bottom-left",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error("[DIAGNOSTIC] Error sending device force-reconnection request.", err);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("forcedConnectionError") + '</span>', {
                        position: "bottom-left",
                        effect: "genie",
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    render() {
        // Classify GSM signal
        let gsmText = "---";
        if (this.props.telemetry.gsm <= 1) {
            gsmText = this.props.t("dead");
        } else if (this.props.telemetry.gsm >= 2 && this.props.telemetry.gsm <= 9) {
            gsmText = this.props.t("morginal");
        } else if (this.props.telemetry.gsm >= 10 && this.props.telemetry.gsm <= 14) {
            gsmText = this.props.t("ok");
        } else if (this.props.telemetry.gsm >= 15 && this.props.telemetry.gsm <= 19) {
            gsmText = this.props.t("good");
        } else if (this.props.telemetry.gsm >= 20 && this.props.telemetry.gsm <= 31) {
            gsmText = this.props.t("excelent");
        } else if (this.props.telemetry.gsm > 31) {
            gsmText = this.props.t("unknown");
        } else {
            gsmText = this.props.t("unknown");
        }

        let breakMotiveText = "---";
        switch (this.props.lastCommnsBrkMtv) {
            case "reserved": {
                breakMotiveText = "---";
                break;
            }
            case "vehicle-shutdown": {
                breakMotiveText = this.props.t("vehicleShutdown");
                break;
            }
            case "fw-update": {
                breakMotiveText = this.props.t("firmwareUpdate");
                break;
            }
            case "power-removal": {
                breakMotiveText = this.props.t("powerSource");
                break;
            }
            case "ka-timeout": {
                breakMotiveText = this.props.t("keepAlive");
                break;
            }
            case "server-cmd": {
                breakMotiveText = this.props.t("serverCommand");
                break;
            }
            case "n/a": {
                breakMotiveText = this.props.t("unknown");
                break;
            }
            default: {
                breakMotiveText = this.props.t("unknown");
                break;
            }
        }

        return (
            <div className={"col-xs-12 col-md-3"} style={{paddingLeft: 0}}>
                <div className={"col-xs-12 row-flex"} style={{paddingLeft: 6, paddingRight: 6}}>
                    <div className={"App_panel"}>
                        <div className={"col-xs-12 text-left App_containerTitle"}>
                            <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("statusReport")}</span>
                        </div>
                        <div className={"col-xs-12 col-sm-6 col-md-12"} style={{padding: 0, marginBottom: 25}}>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <span className="App_small_title" style={{fontStyle: "italic", fontSize: 19, margin: 0}}>{this.props.t("location")}</span>
                                <hr style={{margin: 0, borderColor: "#000000"}}/>
                            </div>
                            <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("latitude")}</p>
                            </div>
                            <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.currentCarLat || this.props.currentCarLat === 0 ? this.props.currentCarLat : "---"}</p>
                            </div>
                            <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("longitude")}</p>
                            </div>
                            <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.currentCarLng || this.props.currentCarLng === 0 ? this.props.currentCarLng : "---"}</p>
                            </div>
                            <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("gpsFix")}</p>
                            </div>
                            <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.fix || this.props.diagnosis.fix === 0 ? this.props.diagnosis.fix : "---"}</p>
                            </div>
                            <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("nrSat")}</p>
                            </div>
                            <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.sat || this.props.diagnosis.sat === 0 ? this.props.diagnosis.sat : "---"}</p>
                            </div>
                            {(this.props.currentCarLng && this.props.currentCarLat) && Math.abs(this.props.currentCarLat) <= 90 && Math.abs(this.props.currentCarLng) <= 180 ? (
                                <div className={"col-xs-12 text-center"} style={{padding: 2}}>
                                    <img src={gMapsIcon} alt={"Google Maps"} width={20} height={20}/>
                                    <a className={"App_black_text"} rel="noopener noreferrer" target={"_blank"} href={"https://www.google.com/maps/search/?api=1&query=" + this.props.currentCarLat + "," + this.props.currentCarLng}>
                                        <b>Google Maps</b>
                                    </a>
                                </div>
                            ) : (
                                <div/>
                            )}
                        </div>

                        <div className={"col-xs-12 col-sm-6 col-md-12"} style={{padding: 0, marginBottom: 25}}>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <span className="App_small_title" style={{fontStyle: "italic", fontSize: 19, margin: 0}}>{this.props.t("gsmSignal")}</span>
                                <hr style={{margin: 0, borderColor: "#000000"}}/>
                            </div>
                            <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("signal")}</p>
                            </div>
                            <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.telemetry.gsm || this.props.telemetry === 0 ? gsmText + "  (" + this.props.telemetry.gsm + ")" : "---"}</p>
                            </div>
                            <div className={"col-xs-12 text-left App_small_title"} style={{padding: 2}}>
                                <i>{this.props.t("lastConnection")}</i>
                            </div>
                            <div className={"col-xs-4 text-right"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("startConn")}</p>
                            </div>
                            <div className={"col-xs-8 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.lastCommnsConnectionStart ? formatDate(this.props.lastCommnsConnectionStart, Intl.DateTimeFormat().resolvedOptions().timeZone) : "---"}</p>
                            </div>
                            <div className={"col-xs-4 text-right"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("endConn")}</p>
                            </div>
                            <div className={"col-xs-8 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{this.props.lastCommnsConnectionEnd ? formatDate(this.props.lastCommnsConnectionEnd, Intl.DateTimeFormat().resolvedOptions().timeZone) : "---"}</p>
                            </div>
                            <div className={"col-xs-4 text-right"} style={{padding: 2}}>
                                <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("breakMotive")}</p>
                            </div>
                            <div className={"col-xs-8 text-left"} style={{padding: 2}}>
                                <p className={"App_black_text"} style={{margin: 1}}>{breakMotiveText}</p>
                            </div>
                        </div>

                        <div className={"col-xs-12 col-sm-6 col-md-12"} style={{padding: 0}}>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <span className="App_small_title" style={{fontStyle: "italic", fontSize: 19, margin: 0}}>{this.props.t("telemetry")}</span>
                                <hr style={{margin: 0, borderColor: "#000000"}}/>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("spd")}.(OBD)</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{(this.props.telemetry.spo || this.props.telemetry.spo === 0) && this.props.telemetry.spo < 500 ? this.props.telemetry.spo : "---"}</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("spd")}.(GPS)</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{(this.props.telemetry.spg || this.props.telemetry === 0) && this.props.telemetry.spg < 500 ? this.props.telemetry.spg : "---"}</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("rpm")}</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.telemetry.rpm || this.props.telemetry === 0 ? this.props.telemetry.rpm : "---"}</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("throttle")}</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{(this.props.telemetry.thr || this.props.telemetry.thr === 0) && this.props.telemetry.thr <= 100 ? this.props.telemetry.thr : "---"} %</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("engTemp")}</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.telemetry.etm || this.props.telemetry.etm === 0 ? this.props.telemetry.etm : "---"} ºC</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("fuelLevel")}</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.telemetry.ful || this.props.telemetry.ful === 0 ? this.props.telemetry.ful : "---"} L</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("battVolt")}</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.diagnosis.bat || this.props.diagnosis.bat === 0 ? (this.props.diagnosis.bat / 1000) : "---"} V</p>
                                </div>
                            </div>
                            <div className={"col-xs-12"} style={{padding: 0}}>
                                <div className={"col-xs-5 text-left"} style={{padding: 2}}>
                                    <p className={"App_small_title"} style={{margin: 0}}>{this.props.t("lastUpdated")}</p>
                                </div>
                                <div className={"col-xs-7 text-left"} style={{padding: 2}}>
                                    <p className={"App_black_text"} style={{margin: 1}}>{this.props.telemetry.srt ? formatDate(this.props.telemetry.srt, Intl.DateTimeFormat().resolvedOptions().timeZone) : "---"}</p>
                                </div>
                            </div>
                        </div>
                        <div className={"col-xs-12"} style={{padding: 0}}>
                            <hr style={{margin: 0, borderColor: "#000000"}}/>
                        </div>
                        <div className={"col-xs-12"} style={{padding: 2}}>
                            <button
                                type={"button"}
                                className={"btn btn-primary btn-block button"}
                                style={{float: "right"}}
                                disabled={!this.props.carID}
                                onClick={this.handleRefreshDevice}
                            >
                                {this.props.t("forceRefresh").toUpperCase()} <i className={"fas fa-sync-alt"}/>
                            </button>
                        </div>
                        <div className={"col-xs-12"} style={{padding: 2}}>
                            <button
                                type={"button"}
                                className={"btn btn-primary btn-block button"}
                                style={{float: "right"}}
                                disabled={!this.props.carID}
                                onClick={this.handleResetDevice}
                            >
                                {this.props.t("forceReset").toUpperCase()} <i className={"fas fa-power-off"}/>
                            </button>
                        </div>
                        <div className={"col-xs-12"} style={{padding: 2}}>
                            <button
                                type={"button"}
                                className={"btn btn-primary btn-block button"}
                                style={{float: "right"}}
                                disabled={!this.props.carID}
                                onClick={this.handleForceNewConnection}
                            >
                                {this.props.t("forceNewConn").toUpperCase()} <i className={"fas fa-signal"}/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class RealtimeGraphs extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            msgDelay: 0,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.telemetry.srt !== this.props.telemetry.srt) {
            this.setState({
                msgDelay: Math.abs(prevProps.telemetry.srt - this.props.telemetry.srt),
            });
        }
    }

    render() {
        return (
            <div className={"col-xs-12"} style={{paddingRight: 6, paddingLeft: 6}}>
                <div className={"App_panel"}>
                    <div className={"col-md-12 text-left App_containerTitle"}>
                        <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("realTimeTelemetry")}</span>
                    </div>
                    <RealTimeGraph
                        graphRef={"chart_speed"}
                        newValue={this.props.telemetry.spo}
                        newValue2={this.props.telemetry.spg}
                        graphTitle={this.props.t("speed") + " (Km/h)"}
                    />
                    <RealTimeGraph
                        graphRef={"chart_rpm"}
                        newValue={this.props.telemetry.rpm}
                        graphTitle={this.props.t("rpm")}
                    />
                    <RealTimeGraph
                        graphRef={"chart_throttle"}
                        newValue={this.props.telemetry.thr}
                        graphTitle={this.props.t("throttle")}
                    />
                    <RealTimeGraph
                        graphRef={"chart_delay"}
                        newValue={this.state.msgDelay / 1000}
                        graphTitle={this.props.t("messageDelay")}
                    />
                </div>
            </div>
        );
    }
}

class PeripheralsList extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            rows: [],
        };

        this.evaluateUpdate = this.evaluateUpdate.bind(this);
    }

    /* LIFE CYCLE */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            (prevProps.diagnosis.per1 !== this.props.diagnosis.per1) ||
            (prevProps.diagnosis.per2 !== this.props.diagnosis.per2) ||
            (prevProps.diagnosis.per3 !== this.props.diagnosis.per3) ||
            (prevProps.diagnosis.per4 !== this.props.diagnosis.per4)
        ) {
            let tempRows = [];

            // CHECK updates for preipherals of this vehicle
            let upd = null;
            for (let i = 0; i < this.props.peripheralUpdateStatus.length; i++) {
                if (this.props.carID === this.props.peripheralUpdateStatus[i].cid) {
                    upd = this.props.peripheralUpdateStatus[i].pfu;
                    break;
                }
            }

            if (this.props.diagnosis.per1) {
                for (let i = 0; i < this.props.diagnosis.per1.length; i++) {
                    Object.keys(this.props.diagnosis.per1[i]).forEach((per, x) => {

                        let evaluated = this.evaluateUpdate(upd, this.props.diagnosis.per1[i][per]);
                        let update_led_color = evaluated.update_led_color;
                        let update_tooltip = evaluated.update_tooltip;

                        tempRows.push(
                            <tr key={per + "_1_" + i}>
                                <td className={"App_black_text"}>{per}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per1[i][per].typ}</td>
                                <td className={"App_black_text"}>{prefixWZeroes(this.props.diagnosis.per1[i][per].cap.toString(2), 32)}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per1[i][per].fwv}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per1[i][per].prv}</td>
                                <td>
                                    <div className={"led-" + update_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"}
                                         style={{marginBottom: 5}}
                                         data-tip={true}
                                         data-for={"per1_led_update_" + i}>
                                        <ReactTooltip id={"per1_led_update_" + i} type={"light"}>
                                            <span className={"App_title"}>{update_tooltip}</span>
                                        </ReactTooltip>
                                    </div>
                                </td>
                            </tr>
                        );
                    });
                }
            }

            if (this.props.diagnosis.per2) {
                for (let i = 0; i < this.props.diagnosis.per2.length; i++) {
                    Object.keys(this.props.diagnosis.per2[i]).forEach((per, x) => {

                        let evaluated = this.evaluateUpdate(upd, this.props.diagnosis.per2[i][per]);
                        let update_led_color = evaluated.update_led_color;
                        let update_tooltip = evaluated.update_tooltip;

                        tempRows.push(
                            <tr key={per + "_2_" + i}>
                                <td className={"App_black_text"}>{per}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per2[i][per].typ}</td>
                                <td className={"App_black_text"}>{prefixWZeroes(this.props.diagnosis.per2[i][per].cap.toString(2), 32)}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per2[i][per].fwv}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per2[i][per].prv}</td>
                                <td>
                                    <div className={"led-" + update_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"}
                                         style={{marginBottom: 5}}
                                         data-tip={true}
                                         data-for={"per2_led_update_" + i}>
                                        <ReactTooltip id={"per2_led_update_" + i} type={"light"}>
                                            <span className={"App_title"}>{update_tooltip}</span>
                                        </ReactTooltip>
                                    </div>
                                </td>
                            </tr>
                        );
                    });
                }
            }

            if (this.props.diagnosis.per3) {
                for (let i = 0; i < this.props.diagnosis.per3.length; i++) {
                    Object.keys(this.props.diagnosis.per3[i]).forEach((per, x) => {

                        let evaluated = this.evaluateUpdate(upd, this.props.diagnosis.per3[i][per]);
                        let update_led_color = evaluated.update_led_color;
                        let update_tooltip = evaluated.update_tooltip;

                        tempRows.push(
                            <tr key={per + "_3_" + i}>
                                <td className={"App_black_text"}>{per}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per3[i][per].typ}</td>
                                <td className={"App_black_text"}>{prefixWZeroes(this.props.diagnosis.per3[i][per].cap.toString(2), 32)}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per3[i][per].fwv}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per3[i][per].prv}</td>
                                <td>
                                    <div className={"led-" + update_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"}
                                         style={{marginBottom: 5}}
                                         data-tip={true}
                                         data-for={"per3_led_update_" + i}>
                                        <ReactTooltip id={"per3_led_update_" + i} type={"light"}>
                                            <span className={"App_title"}>{update_tooltip}</span>
                                        </ReactTooltip>
                                    </div>
                                </td>
                            </tr>
                        );
                    });
                }
            }

            if (this.props.diagnosis.per4) {
                for (let i = 0; i < this.props.diagnosis.per4.length; i++) {
                    Object.keys(this.props.diagnosis.per4[i]).forEach((per, x) => {

                        let evaluated = this.evaluateUpdate(upd, this.props.diagnosis.per4[i][per]);
                        let update_led_color = evaluated.update_led_color;
                        let update_tooltip = evaluated.update_tooltip;

                        tempRows.push(
                            <tr key={per + "_4_" + i}>
                                <td className={"App_black_text"}>{per}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per4[i][per].typ}</td>
                                <td className={"App_black_text"}>{prefixWZeroes(this.props.diagnosis.per4[i][per].cap.toString(2), 32)}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per4[i][per].fwv}</td>
                                <td className={"App_black_text"}>{this.props.diagnosis.per4[i][per].prv}</td>
                                <td>
                                    <div className={"led-" + update_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"}
                                         style={{marginBottom: 5}}
                                         data-tip={true}
                                         data-for={"per4_led_update_" + i}>
                                        <ReactTooltip id={"per4_led_update_" + i} type={"light"}>
                                            <span className={"App_title"}>{update_tooltip}</span>
                                        </ReactTooltip>
                                    </div>
                                </td>
                            </tr>
                        );
                    });
                }
            }

            this.setState({
                rows: tempRows,
            });
        }
    }

    /* HANDLERS */
    evaluateUpdate(upd, per) {
        let update_led_color = "";
        let update_tooltip = "";

        if (upd !== null) {
            if (upd.perTypeId === per.typ) {
                switch (upd.sts) {
                    case(0): {
                        // UP TO DATE
                        update_led_color = "green";
                        update_tooltip = "UP TO DATE";
                        break;
                    }
                    case(1): {
                        // UPDATING
                        update_led_color = "yellow";
                        update_tooltip = "UPDATING (" + upd.prg + "%)";
                        break;
                    }
                    case(2): {
                        // UPDATE COMPLETE
                        update_led_color = "blue";
                        update_tooltip = "UPDATE COMPLETE";
                        break;
                    }
                    default: {
                        // UP TO DATE
                        update_led_color = "green";
                        update_tooltip = "UP TO DATE";
                        break;
                    }
                }
            } else {
                // UP TO DATE
                update_led_color = "green";
                update_tooltip = "UP TO DATE";
            }
        } else {
            // UP TO DATE
            update_led_color = "green";
            update_tooltip = "UP TO DATE";
        }

        return {
            update_led_color: update_led_color,
            update_tooltip: update_tooltip,
        };
    }

    /* RENDER */
    render() {
        return (
            <div className={"col-xs-12"} style={{paddingRight: 6, paddingLeft: 6}}>
                <div className={"App_panel row-flex"}>
                    <div className={"col-xs-12 text-left App_containerTitle"}>
                        <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("peripherals")}</span>
                    </div>
                    <div className={"col-xs-12 table-scroll-parent"} style={{height: "18vh"}}>
                        <table className={"table text-center table-scroll-child"} style={{fontSize: 16}}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("id")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("type")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("capabilities")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("firmware")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("protocol")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("update")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.rows.length > 0 ? (
                                this.state.rows
                            ) : (
                                <tr>
                                    <td colSpan={5} className={"App_black_text"}><b>{this.props.t("noDevices")}</b></td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

class TopTable extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            carData: [],
            rows: <tr/>,
            tooltips: <div/>,
            show: false,
            searchVehicle: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.refreshTableInfo = this.refreshTableInfo.bind(this);
        this.makeRows = this.makeRows.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChangeVehicleSearch = this.handleChangeVehicleSearch.bind(this);
        this.handleInnerGlow = this.handleInnerGlow.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        this.refreshTableInfo();
        this.refreshInterval = setInterval(() => {
            this.refreshTableInfo();
        }, auto_refresh);
    }

    componentWillUnmount() {
        clearInterval(this.refreshInterval);
    }

    /* HANDLERS */
    handleChange(e, id) {
        this.props.updateCurrentCarID(id, () => {
            this.makeRows();
        });
    }

    handleShowModal() {
        this.setState({show: true});
    }

    handleClose() {
        this.setState({show: false,});
    }

    handleChangeVehicleSearch(e) {
        e.preventDefault();
        if (!isNaN(e.target.value)) {
            let number = e.target.value;
            this.setState({
                searchVehicle: number,
            }, () => {
                this.makeRows();
            });
        }
    }

    refreshTableInfo() {
        Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("gatheringInfo") + '!</span>', {
            position: "bottom-left",
            effect: "genie",
            beep: false,
            timeout: 5000,
            offset: 150
        });
        const helper = this;
        $.ajax({
            type: "GET",
            url: telemetryIP + ":" + messagePort + "/session-devices-minimal-diagnosis-refresh?eventId=" + helper.props.eventID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function (data) {
                console.log("[DIAGNOSTICS] Successfully sent device list refresh request.");
                helper.setState({
                    carData: data.dat,
                }, () => {
                    // UPDATE VEHICLE LIST AS WELL
                    helper.props.getCarList((err, message) => {
                        if (err) {
                            console.error(message, err);
                        } else {
                            helper.makeRows();
                        }
                    });

                    // SEND PERIPHERAL UPDATE STATUS TO PARENT COMPONENT
                    let temp_pfu = [];
                    for (let i = 0; i < helper.state.carData.length; i++) {
                        temp_pfu.push({
                            cid: helper.state.carData[i].cid,
                            pfu: helper.state.carData[i].pfu,
                        });
                    }
                    helper.props.updatePeripheralUpdateStatus(temp_pfu);

                    Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("diagTableUpdated") + '!</span>', {
                        position: "bottom-left",
                        effect: "genie",
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                });
            }, error: function (err) {
                if (err) {
                    console.error("[DIAGNOSTIC] Error sending device list refresh request.", err);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("errorUpdateTable") + '!</span>', {
                        position: "bottom-left",
                        effect: "genie",
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                    $(".loading").fadeOut();
                }
            }
        });
    }

    handleInnerGlow() {
        this.props.handleToggleGlow(() => {
            this.makeRows();
        });
    }

    /* RENDER METHODS */
    makeRows() {
        let rows = [];
        let tooltips = [];

        for (let c = 0; c < this.props.carList.length; c++) {
            if (!isNaN(parseInt(this.state.searchVehicle))) {
                if (("" + this.props.carList[c].livery_number).indexOf(this.state.searchVehicle) === -1) {
                    continue;
                }
            }
            for (let i = 0; i < this.state.carData.length; i++) {
                if (this.props.carList[c].id === this.state.carData[i].cid) {
                    // Process device ON LED light color
                    let device_on_led_color = "";
                    let device_on_tooltip = "";
                    if (parseInt(this.state.carData[i].dif) < device_on_interval) {
                        device_on_led_color = "green";
                        device_on_tooltip = this.props.t("deviceON");
                    } else {
                        device_on_led_color = "red";
                        device_on_tooltip = this.props.t("deviceOFF");
                    }

                    // Process Race Status Indicator
                    let statusColor = "";
                    let statusText = "";
                    let statusOpacity = "";

                    switch (this.props.carList[c].rsi) {
                        case (2): {
                            statusColor = "#be2000";
                            statusText = "DNF";
                            statusOpacity = "40";
                            break;
                        }
                        case (3): {
                            statusColor = "#e09d00";
                            statusText = "DNS";
                            statusOpacity = "40";
                            break;
                        }
                        default: {
                            statusColor = "";
                            statusOpacity = "";
                            break;
                        }
                    }

                    // Process Endpoint status LED light color
                    let endpoint_led_color = "";
                    let endpoint_tooltip = "";
                    switch (this.state.carData[i].eos) {
                        case ("ONLINE"): {
                            endpoint_led_color = "green";
                            endpoint_tooltip = this.props.t("endpoint") + " " + this.props.t("online");
                            break;
                        }
                        case ("OFFLINE"): {
                            endpoint_led_color = "red";
                            endpoint_tooltip = this.props.t("endpoint") + " " + this.props.t("offline");
                            break;
                        }
                        case ("ATTACHED"): {
                            endpoint_led_color = "blue";
                            endpoint_tooltip = this.props.t("endpoint") + " " + this.props.t("attached");
                            break;
                        }
                        case ("BLOCKED"): {
                            endpoint_led_color = "yellow";
                            endpoint_tooltip = this.props.t("endpoint") + " " + this.props.t("blocked");
                            break;
                        }
                        default: {
                            endpoint_led_color = "red";
                            endpoint_tooltip = this.props.t("endpoint") + ": " + this.props.t("unknownState");
                            break;
                        }
                    }

                    // Process SIM card status LED light color
                    let sim_led_color = "";
                    let sim_tooltip = "";
                    switch (this.state.carData[i].sas) {
                        case -1: {
                            sim_led_color = "yellow";
                            sim_tooltip = this.props.t("unknownState");
                            break;
                        }
                        case 0: {
                            sim_led_color = "blue";
                            sim_tooltip = "SIM " + this.props.t("issued");
                            break;
                        }
                        case 1: {
                            sim_led_color = "green";
                            sim_tooltip = "SIM " + this.props.t("active");
                            break;
                        }
                        case 2: {
                            sim_led_color = "red";
                            sim_tooltip = "SIM " + this.props.t("suspended");
                            break;
                        }
                        default: {
                            sim_led_color = "yellow";
                            sim_tooltip = this.props.t("unknownState");
                            break;
                        }
                    }

                    // Process OBD status LED light color
                    let obd_led_color = "";
                    let obd_tooltip = "";
                    switch (this.state.carData[i].ost) {
                        case (0): {
                            obd_led_color = "red";
                            obd_tooltip = "OBD " + this.props.t("notWorking");
                            break;
                        }
                        case (1): {
                            obd_led_color = "yellow";
                            obd_tooltip = "OBD " + this.props.t("searchingProtocol");
                            break;
                        }
                        case (2): {
                            obd_led_color = "green";
                            obd_tooltip = "OBD " + this.props.t("connected");
                            break;
                        }
                        default: {
                            obd_led_color = "red";
                            obd_tooltip = "OBD " + this.props.t("unknownState");
                            break;
                        }
                    }
                    // Override to RED color if device turned OFF
                    if (device_on_led_color === "red") {
                        obd_led_color = "red";
                        obd_tooltip = this.props.t("deviceOFF");
                    }

                    // Process GPS status LED light color
                    let gps_led_color = "";
                    let gps_tooltip = "";
                    switch (this.state.carData[i].gst) {
                        case (0): {
                            gps_led_color = "white";
                            gps_tooltip = "GPS " + this.props.t("notWorking");
                            break;
                        }
                        case (1): {
                            gps_led_color = "red";
                            gps_tooltip = "GPS " + this.props.t("waitingFix");
                            break;
                        }
                        case (3): {
                            gps_led_color = "blue";
                            gps_tooltip = "GPS " + this.props.t("initializing");
                            break;
                        }
                        case (2): {
                            if (this.state.carData[i].sat <= 5) {
                                gps_led_color = "yellow";
                                gps_tooltip = this.props.t("weakSignal") + " (" + this.state.carData[i].sat + " sat.)";
                            } else if (this.state.carData[i].sat >= 6 && this.state.carData[i].sat <= 9) {
                                gps_led_color = "blue";
                                gps_tooltip = this.props.t("mildSignal") + " (" + this.state.carData[i].sat + " sat.)";
                            } else if (this.state.carData[i].sat >= 10) {
                                gps_led_color = "green";
                                gps_tooltip = this.props.t("strongSignal") + " (" + this.state.carData[i].sat + " sat.)";
                            } else {
                                gps_led_color = "red";
                                gps_tooltip = this.props.t("gpsError");
                            }
                            break;
                        }
                        case (4): {
                            gps_led_color = "red";
                            gps_tooltip = this.props.t("gpsError");
                            break;
                        }
                        default: {
                            gps_led_color = "red";
                            gps_tooltip = "GPS " + this.props.t("unknownState");
                            break;
                        }
                    }
                    // Override to RED color if device turned OFF
                    if (device_on_led_color === "red") {
                        gps_led_color = "red";
                        gps_tooltip = this.props.t("deviceOFF");
                    }

                    // Process GSM status LED light color
                    let gsm_led_color = "";
                    let gsm_tooltip = "";
                    let gsm_icon = gsm_0;
                    if (this.state.carData[i].gsm <= 1) {
                        gsm_tooltip = this.props.t("deadSignal");
                        gsm_led_color = "red";
                        gsm_icon = gsm_1;
                    } else if (this.state.carData[i].gsm >= 2 && this.state.carData[i].gsm <= 9) {
                        gsm_tooltip = this.props.t("marginalSignal");
                        gsm_led_color = "yellow";
                        gsm_icon = gsm_2;
                    } else if (this.state.carData[i].gsm >= 10 && this.state.carData[i].gsm <= 14) {
                        gsm_tooltip = this.props.t("stableSignal");
                        gsm_led_color = "blue";
                        gsm_icon = gsm_3;
                    } else if (this.state.carData[i].gsm >= 15 && this.state.carData[i].gsm <= 19) {
                        gsm_tooltip = this.props.t("goodSignal");
                        gsm_led_color = "green";
                        gsm_icon = gsm_4;
                    } else if (this.state.carData[i].gsm >= 20 && this.state.carData[i].gsm <= 31) {
                        gsm_tooltip = this.props.t("excelentSignal");
                        gsm_led_color = "green";
                        gsm_icon = gsm_5;
                    } else if (this.state.carData[i].gsm > 31) {
                        gsm_tooltip = this.props.t("unknownState");
                        gsm_led_color = "yellow";
                        gsm_icon = gsm_0;
                    } else {
                        gsm_tooltip = this.props.t("unknownState");
                        gsm_led_color = "yellow";
                        gsm_icon = gsm_0;
                    }
                    // Override to RED color if device turned OFF
                    if (device_on_led_color === "red") {
                        gsm_led_color = "red";
                        gsm_tooltip = this.props.t("deviceOFF");
                        gsm_icon = gsm_0;
                    }

                    // Process Update status LED light color
                    let fw_update_led_color = "";
                    let fw_update_tooltip = "";
                    if (this.state.carData[i].fwu !== null) {
                        switch (this.state.carData[i].fwu.sts) {
                            case(0): {
                                fw_update_led_color = "yellow";
                                fw_update_tooltip = "Update available";
                                break;
                            }
                            case(1): {
                                fw_update_led_color = "blue";
                                fw_update_tooltip = "Updating (" + this.state.carData[i].fwu.prg + "%)";
                                break;
                            }
                            case(2): {
                                fw_update_led_color = "green";
                                fw_update_tooltip = "Up to date";
                                break;
                            }
                            default: {
                                fw_update_led_color = "red";
                                fw_update_tooltip = this.props.t("unknownState");
                                break;
                            }
                        }
                    } else {
                        if (this.props.carList[c].available_firmware_version_id === this.props.carList[c].current_firmware_version_id) {
                            fw_update_led_color = "green";
                            fw_update_tooltip = this.props.t("upToDate");
                        } else {
                            fw_update_led_color = "red";
                            fw_update_tooltip = this.props.t("updateNeeded");
                        }
                    }

                    // Check if device turned ON
                    let ping = null;
                    if (device_on_led_color !== "red") {
                        ping = this.state.carData[i].png;
                    }

                    // Process TEAM MANAGER ONLINE team name color
                    let tmc_tooltip = this.props.t("teamManager") + " ";
                    if (this.state.carData[i].tmc > 0) {
                        tmc_tooltip += this.props.t("online").toUpperCase();
                    } else {
                        tmc_tooltip += this.props.t("offline").toUpperCase();
                    }

                    tooltips.push(
                        <div key={this.props.carList[c].livery_number}>
                            <ReactTooltip id={"team_manager_online_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{tmc_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"device_on_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{device_on_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"endpoint_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{endpoint_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"sim_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{sim_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"gps_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{gps_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"gsm_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{gsm_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"obd_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{obd_tooltip}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"fw_update_" + this.props.carList[c].livery_number} type={"light"}>
                                <span className={"App_title"}>{fw_update_tooltip}</span>
                            </ReactTooltip>
                        </div>
                    );

                    rows.push(
                        <tr
                            key={this.props.carList[c].id}
                            style={{cursor: "pointer", backgroundColor: (statusColor + statusOpacity)}}
                            onClick={(event) => this.handleChange(event, this.props.carList[c].id)}
                            className={"onHover text-center App_white_text"}
                        >
                            <td style={{valign: "center"}}>
                                <input type={"radio"}
                                       name={"optradio"}
                                       className={"form-radio"}
                                       readOnly={true}
                                       checked={(parseInt(this.props.carID) === parseInt(this.props.carList[c].id))}
                                />
                            </td>
                            <td>
                                {statusText} #{this.props.carList[c].livery_number}
                            </td>
                            <td data-tip={true} data-for={"team_manager_online_" + this.props.carList[c].livery_number} className={this.state.carData[i].tmc > 1 ? "glow-green" : "glow-red-static"}>
                                {"(" + this.state.carData[i].tmc + ") " + this.props.carList[c].short_name}
                            </td>
                            <td>
                                <div className={"led-" + device_on_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}} data-tip={true} data-for={"device_on_" + this.props.carList[c].livery_number}>
                                    <i className={"fas fa-power-off"} style={{paddingTop: 3, color: "#000000"}}/>
                                </div>
                            </td>
                            <td>
                                <div style={{position: "relative"}}>
                                    <i className={"fas fa-signal glow-" + gsm_led_color + (this.props.glowEffect ? "" : "-static")} style={{marginTop: 5, fontSize: 21}}/>
                                    <img
                                        src={gsm_icon}
                                        alt={""}
                                        className={"glow-" + this.props.gsmStatusLEDcolor + (this.props.glowEffect ? "" : "-static")}
                                        height={24}
                                        data-tip={true}
                                        data-for={"gsm_" + this.props.carList[c].livery_number}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)"
                                        }}/>
                                </div>
                            </td>
                            <td>
                                <i className={"fas fa-satellite-dish glow-" + gps_led_color + (this.props.glowEffect ? "" : "-static")} data-tip={true} data-for={"gps_" + this.props.carList[c].livery_number} style={{fontSize: 24}}/>
                            </td>
                            <td>{this.props.carList[c].speedSource}</td>
                            <td>
                                <div className={"led-" + endpoint_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}} data-tip={true} data-for={"endpoint_" + this.props.carList[c].livery_number}/>
                            </td>
                            <td>
                                <div className={"led-" + sim_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}} data-tip={true} data-for={"sim_" + this.props.carList[c].livery_number}/>
                            </td>
                            <td>
                                <div className={"led-" + obd_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}} data-tip={true} data-for={"obd_" + this.props.carList[c].livery_number}/>
                            </td>
                            <td>{this.props.carList[c].current_firmware_version_id ? this.props.carList[c].current_firmware_version_id : "---"}</td>
                            <td>
                                <div className={"led-" + fw_update_led_color + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}} data-tip={true} data-for={"fw_update_" + this.props.carList[c].livery_number}/>
                            </td>
                            <td>{ping ? ping + " ms" : "---"}</td>
                        </tr>
                    );
                    break;
                }
            }
        }

        this.setState({
            rows: rows,
            tooltips: tooltips,
        }, () => {
            $(".loading").fadeOut();
        });
    }

    render() {
        return (
            <div className={"row"}>
                <Alert stack={{limit: 2}} html={true}/>
                <div className={"col-xs-12"}>
                    <div className={"col-xs-2"}>
                        <input
                            className={"form-control App_black_text"}
                            style={{border: "2px solid #ed2126", height: 40}}
                            value={this.state.searchVehicle}
                            placeholder={"000"}
                            type={"text"}
                            onChange={this.handleChangeVehicleSearch}
                        />
                    </div>
                    <div className={"col-xs-3 vcenter"} style={{height: 40}}>
                        <span className={"App_big_white_text"}>{(this.props.numConnectedClients && this.props.numConnectedClients >= 0 ? this.props.numConnectedClients : "---") + " " + this.props.t("connectedClients")}</span>
                    </div>
                    <div className={"col-xs-3"} style={{paddingBottom: 10}}>
                        <button
                            type={"button"}
                            className={"btn btn-primary btn-block button"}
                            style={{float: "right"}}
                            onClick={this.refreshTableInfo}
                        >
                            {this.props.t("refresh").toUpperCase()} <i className={"fas fa-sync-alt"}/>
                        </button>
                    </div>
                    <div className={"col-xs-3"} style={{paddingBottom: 10}}>
                        <button
                            type={"button"}
                            className={"btn btn-primary btn-block button"}
                            style={{float: "right"}}
                            onClick={this.handleShowModal}
                        >
                            {this.props.t("legend")} <i className={"fas fa-info-circle"}/>
                        </button>
                    </div>
                    <div className={"col-xs-1"} style={{paddingBottom: 10}}>
                        <button
                            type={"button"}
                            className={"btn btn-primary btn-block button"}
                            style={this.props.glowEffect ? {float: "right"} : {float: "right", backgroundColor: "#4b4b4b"}}
                            onClick={this.handleInnerGlow}
                        >
                            <i className="far fa-lightbulb"/>
                        </button>
                    </div>
                </div>
                <div className={"col-xs-12"}>
                    <div className={"table-scroll-parent"} style={{whiteSpace: "nowrap", height: "auto"}}>
                        <div className={"table-scroll-child table-responsive"}>
                            <table className={"table table-condensed"}>
                                <thead>
                                <tr>
                                    <th className={"App_smallHeader"}/>
                                    <th className={"App_smallHeader"}/>
                                    <th className={"App_smallHeader"}>{this.props.t("team")}</th>
                                    <th className={"App_smallHeader"}>Sts</th>
                                    <th className={"App_smallHeader"}>GSM</th>
                                    <th className={"App_smallHeader"}>GPS</th>
                                    <th className={"App_smallHeader"}>Spd Src</th>
                                    <th className={"App_smallHeader"}>EndPnt</th>
                                    <th className={"App_smallHeader"}>SIM</th>
                                    <th className={"App_smallHeader"}>OBD</th>
                                    <th className={"App_smallHeader"}>Firmware</th>
                                    <th className={"App_smallHeader"}>Upd</th>
                                    <th className={"App_smallHeader"}>Ping</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.rows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {this.state.tooltips}
                <Modal open={this.state.show}
                       onClose={this.handleClose}
                       center={false}
                       classNames={{modal: "big-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <span className={"App_title"}>{this.props.t("ledColorScheme")}</span>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <span className={"App_black_text"}><b>{this.props.t("deviceState")}</b></span>
                        <table className={"table"}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("deviceStateComm_1")} {device_on_interval / 1000}s</th>
                                <th className={"App_smallHeader"}>{this.props.t("deviceStateComm_2")} {device_on_interval / 1000}s {this.props.t("deviceStateComm_2_1")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={"led-red" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-green" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <span className={"App_black_text"}><b>{this.props.t("endpointState")}</b></span>
                        <table className={"table"}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("online")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("blocked")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("attached")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("offline")} / {this.props.t("unknown")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={"led-green" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-yellow" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-blue" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-red" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <span className={"App_black_text"}><b>{this.props.t("simCardState")}</b></span>
                        <table className={"table"}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("unknownState")}</th>
                                <th className={"App_smallHeader"}>SIM {this.props.t("issued")}</th>
                                <th className={"App_smallHeader"}>SIM {this.props.t("active")}</th>
                                <th className={"App_smallHeader"}>SIM {this.props.t("suspended")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={"led-yellow" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-blue" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-green" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-red" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <span className={"App_black_text"}><b>{this.props.t("gpsState")}</b></span>
                        <table className={"table"}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("Not Working")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("ok")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("waitingFix")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("initializing")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("unknownState")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={"led-white" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-green" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-yellow" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-blue" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-red" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <span className={"App_black_text"}><b>{this.props.t("obdState")}</b></span>
                        <table className={"table"}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("notWorking")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("searchingProtocol")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("connected")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={"led-red" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-yellow" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-green" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <span className={"App_black_text"}><b>{this.props.t("updateState")}</b></span>
                        <table className={"table"}>
                            <thead>
                            <tr>
                                <th className={"App_smallHeader"}>{this.props.t("unknownState")} / {this.props.t("updateNeeded")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("updateAvailable")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("updating")}</th>
                                <th className={"App_smallHeader"}>{this.props.t("upToDate")}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={"led-red" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-yellow" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-blue" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                                <td>
                                    <div className={"led-green" + (this.props.glowEffect ? "" : "-static") + " col-xs-offset-3 col-md-offset-0"} style={{marginBottom: 5}}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleClose}
                            className={"btn App_text"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutDiagMonitor));
